export const getDateMonthsAgo = (monthsAgo: number, fromDate: Date = new Date()): Date => {
    const date = new Date(fromDate);
    date.setMonth(date.getMonth() - monthsAgo);
    return date;
};

export function formattedDate(date: Date) {
    return `${date.getFullYear()}-${`0${date.getMonth() + 1}`.slice(-2)}-${`0${date.getDate()}`.slice(-2)}`;
}

export function createDate(year: number, month?: number) {
    let date = new Date(Date.now() + 24 * 60 * 60 * 1000);
    date.setFullYear(date.getFullYear() + year);

    if (month) date.setMonth(date.getMonth() + month);

    return date;
}

export function createDateToISOString(year: number, month?: number) {
    return createDate(year, month).toISOString();
}

export const formatOrderDate = (dateString?: Date | null): string => {
    if (!dateString) return 'No information';

    return new Date(dateString).toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        timeZone: 'Europe/Paris',
    });
};
